// src/components/dashboard/Header/Header.jsx
import React, { useState, useEffect, useRef } from "react";
import WelcomeSection from "./WelcomeSection";
import UserProfile from "./UserProfile";

const Header = ({ userName, userEmail, fullName, isLoading, onLogout }) => {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);
  const scrollThreshold = useRef(0);

  useEffect(() => {
    const mainContentArea = document.querySelector(".smai-main-content-area");
    const dashboardContainer = document.querySelector(
      ".smai-dashboard-container"
    );

    if (!mainContentArea || !dashboardContainer) return;

    const handleScroll = () => {
      const currentScrollY = mainContentArea.scrollTop;

      // Always show at the very top
      if (currentScrollY < 10) {
        setIsVisible(true);
        dashboardContainer.classList.remove("header-hidden");
        scrollThreshold.current = 0;
        lastScrollY.current = currentScrollY;
        return;
      }

      // Scrolling down
      if (currentScrollY > lastScrollY.current) {
        // Hide after scrolling down 80px from last show position
        if (currentScrollY > scrollThreshold.current + 80) {
          setIsVisible(false);
          dashboardContainer.classList.add("header-hidden");
        }
      }
      // Scrolling up
      else if (currentScrollY < lastScrollY.current) {
        // Only show if scrolled up significantly (150px) from where it was hidden
        if (isVisible === false && currentScrollY < lastScrollY.current - 150) {
          setIsVisible(true);
          dashboardContainer.classList.remove("header-hidden");
          scrollThreshold.current = currentScrollY;
        }
      }

      lastScrollY.current = currentScrollY;
    };

    // Throttle scroll events
    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    mainContentArea.addEventListener("scroll", throttledHandleScroll, {
      passive: true,
    });

    return () => {
      mainContentArea.removeEventListener("scroll", throttledHandleScroll);
      if (dashboardContainer) {
        dashboardContainer.classList.remove("header-hidden");
      }
    };
  }, [isVisible]);

  return (
    <header
      className="smai-dashboard-header"
      style={{
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? "auto" : "none",
        transition: "opacity 0.3s ease-in-out",
      }}
    >
      <WelcomeSection userName={fullName || userName} isLoading={isLoading} />
      <UserProfile
        userName={userName}
        userEmail={userEmail}
        fullName={fullName}
        isLoading={isLoading}
        onLogout={onLogout}
      />
    </header>
  );
};

export default Header;
